import { render, staticRenderFns } from "./DevMark.vue?vue&type=template&id=5ea3f2d6&scoped=true&lang=pug"
import script from "./DevMark.vue?vue&type=script&lang=ts"
export * from "./DevMark.vue?vue&type=script&lang=ts"
import style0 from "./DevMark.vue?vue&type=style&index=0&id=5ea3f2d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea3f2d6",
  null
  
)

export default component.exports